/*
These functions make sure WordPress
and Foundation play nice together.
*/
$ = jQuery;
function hero_height(){
	var minus = $('.header').height();
	var winHeight = window.innerHeight;
	$('.hero-bg').height(winHeight);

}
WebFont.load({
	google: {
		families: ['Montserrat:400,600,800']
	}
});
// $( window ).load(function() {
// 	$('.graphics , .top-bar-right').css('opacity' , 1);
// });
$(window).resize(function(){
	//hero_height();
});
$(window).on("scroll", function() {
	if($(window).scrollTop() > 50) {
		$("header.header").addClass("active");
	} else {
		//remove the background property so it comes transparent again (defined in your css)
		$("header.header").removeClass("active");
	}
});

function changeSidebar(newSize){
	var large = newSize === 'large';
	var medium = newSize === 'medium';
	var small = newSize === 'small';
	if (large || medium || small){
		var getHtml = $('#blog-sidebar-area .grid-container');
		$('#sidebar-content').append(getHtml.html());
	}
}


$(window).on('changed.zf.mediaquery', function(event, newSize, oldSize) {
	changeSidebar(newSize);
});
$.fn.isInViewport = function() {
    var elementTop = $(this).offset().top;
    var elementBottom = elementTop + $(this).outerHeight();

    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();

    return elementBottom > viewportTop && elementTop < viewportBottom;
};
jQuery(document).ready(function($) {
	changeSidebar(Foundation.MediaQuery.current);

	if ($('.header').isInViewport()){
		$(this).addClass('.active');
	}

   gsap.registerPlugin(ScrollTrigger);
        gsap.registerPlugin(ScrollToPlugin);

        gsap.utils.toArray('.branding .cell').forEach(fadein => {
        	 gsap.fromTo(fadein, { autoAlpha: 0, y: 50 }, {
                scrollTrigger: { trigger: fadein, start: "top 80%", once: true,
                },
                duration: 1, autoAlpha: 1, y: 0
            });


		});
        gsap.utils.toArray('.grid-container').forEach(fadein => {

            gsap.fromTo(fadein, { autoAlpha: 0, y: 50 }, {
                scrollTrigger: { trigger: fadein, start: "top 80%", once: true,
                },
                duration: 1, autoAlpha: 1, y: 0
            });

        });




	var $grid = $('.lgc-isotope').isotope({
		percentPosition: true,
		itemSelector: '.lgc-isotope-grid-item',
		masonry: {
			columnWidth: '.lgc-isotope-grid-sizer',
		//	gutterWidth: 10
		},
		fitRows: {
		//	gutter: 20
		}
	});



	//
	// var faded_works = $('.faded-works');
	// faded_works.slick({
	// 	infinite: true,
	// 	slidesToShow: 1,
	// 	slidesToScroll: 1,
	// 	arrows: false,
	// 	fade: true,
	// 	cssEase: 'linear',
	// 	autoplay : false
	// });
	var lgc_worked_for = $('.worked-for');
	lgc_worked_for.slick({
		infinite: true,
		slidesToShow: 5,
		slidesToScroll: 1,
		arrows: false,
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 5,
					slidesToScroll: 1,
				}
			},
			{
				breakpoint: 600,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 1
				}
			},
			{
				breakpoint: 480,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1
				}
			}]

	});

	var lgc_slider = $('.lgc-slider');
	lgc_slider.slick({
		infinite: false,
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: false,
		variableWidth: true,
	});


	// On swipe event
	lgc_slider.on('afterChange', function(event, slick, direction){

		var current_slide = $(this).slick('slickCurrentSlide') + 1;
		$('.lgc-slider-arrows .current').html(current_slide);
		// left
	});
	$('.lgc-slider-arrows .prev').on('click' , function(){
		lgc_slider.slick('slickPrev');
	});
	$('.lgc-slider-arrows .next').on('click' , function(){
		lgc_slider.slick('slickNext');
	});

	let slider_review = $('#review-slider');
	slider_review.slick({
		dots: false,
		arrows : false,
		autoplay: true,
	});

	let slider_values = $('#values-gallery');
	slider_values.slick({
		dots: false,
		arrows : false,
		autoplay: true,
	});

	$('#review-nav li').each(function(){
		$(this).on('click' , function () {
			slideIndex = $(this).index();
			slider_review.slick('slickGoTo', parseInt(slideIndex));
			slider_review.slick('slickPause');
		});
	});

	// On before slide change
	slider_review.on('beforeChange', function(event, slick, currentSlide, nextSlide){
		var review_li = $('#review-nav li');
		review_li.removeClass('active');
		review_li.eq(nextSlide ).addClass('active');
	});

	// var scene = document.getElementById('scene');
	// var parallaxInstance = new Parallax(scene);
	//hero_height();
	// Remove empty P tags created by WP inside of Accordion and Orbit
	jQuery('.accordion p:empty, .orbit p:empty').remove();

	// Adds Flex Video to YouTube and Vimeo Embeds
	jQuery('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
		if ( jQuery(this).innerWidth() / jQuery(this).innerHeight() > 1.5 ) {
		  jQuery(this).wrap("<div class='widescreen responsive-embed'/>");
		} else {
		  jQuery(this).wrap("<div class='responsive-embed'/>");
		}
	});

	function changeContent($id , e){
		e.preventDefault();

		$('.services-content--item , .read-more-service , .masonry-css-item-slider').removeClass('active').addClass('in');
		if ($id !== 'all') {
			//console.log($id);
			$('.services-content--item[data-id="' + $id + '"] , .masonry-css-item[data-id="' + $id + '"]').addClass('active');

			$('.masonry-css-item-slider[data-id*=","] , .services-content--item[data-id*=","]').each(function(){
				var multiid = $(this).data('id');
				var multis = multiid.split(",");
				if (multis.includes($id.toString())){
					$(this).addClass('active');
				}
			});
		} else {
			$('.masonry-css-item-slider').addClass('active').addClass('in');
		}
		$('.read-more-service[data-id='+$id+']').addClass('active');
	}


/*	$('.read-more-service , #mobile-filter').each(function(){

		$(this).on('change' , function (e) {
			var $id = this.value;
			changeContent($id , e);
		});
		$(this).on('click' , function (e) {
			var $id = $(this).data('id');
			changeContent($id , e);
		});
	});

	$('.read-more-service.active').trigger('click');
*/
	(function ($) {
		$.fn.countTo = function (options) {
			options = options || {};

			return $(this).each(function () {
				// set options for current element
				var settings = $.extend({}, $.fn.countTo.defaults, {
					from:            $(this).data('from'),
					to:              $(this).data('to'),
					speed:           $(this).data('speed'),
					refreshInterval: $(this).data('refresh-interval'),
					decimals:        $(this).data('decimals')
				}, options);

				// how many times to update the value, and how much to increment the value on each update
				var loops = Math.ceil(settings.speed / settings.refreshInterval),
					increment = (settings.to - settings.from) / loops;

				// references & variables that will change with each update
				var self = this,
					$self = $(this),
					loopCount = 0,
					value = settings.from,
					data = $self.data('countTo') || {};

				$self.data('countTo', data);

				// if an existing interval can be found, clear it first
				if (data.interval) {
					clearInterval(data.interval);
				}
				data.interval = setInterval(updateTimer, settings.refreshInterval);

				// initialize the element with the starting value
				render(value);

				function updateTimer() {
					value += increment;
					loopCount++;

					render(value);

					if (typeof(settings.onUpdate) == 'function') {
						settings.onUpdate.call(self, value);
					}

					if (loopCount >= loops) {
						// remove the interval
						$self.removeData('countTo');
						clearInterval(data.interval);
						value = settings.to;

						if (typeof(settings.onComplete) == 'function') {
							settings.onComplete.call(self, value);
						}
					}
				}

				function render(value) {
					var formattedValue = settings.formatter.call(self, value, settings);
					$self.html(formattedValue);
				}
			});
		};

		$.fn.countTo.defaults = {
			from: 0,               // the number the element should start at
			to: 0,                 // the number the element should end at
			speed: 1000,           // how long it should take to count between the target numbers
			refreshInterval: 100,  // how often the element should be updated
			decimals: 0,           // the number of decimal places to show
			formatter: formatter,  // handler for formatting the value before rendering
			onUpdate: null,        // callback method for every time the element is updated
			onComplete: null       // callback method for when the element finishes updating
		};

		function formatter(value, settings) {
			return value.toFixed(settings.decimals);
		}
	}(jQuery));

	jQuery(function ($) {
		// custom formatting example
		$('.count-number').data('countToOptions', {
			formatter: function (value, options) {
				return value.toFixed(options.decimals).replace(/\B(?=(?:\d{3})+(?!\d))/g, ',');
			}
		});

		// start all the timers
		$('.timer').each(count);

		function count(options) {
			var $this = $(this);
			options = $.extend({}, options || {}, $this.data('countToOptions') || {});
			$this.countTo(options);
		}
	});

});
